module.exports = __webpack_public_path__ + "static/media/top14FeaturesBanner_Tablet_738x57px_@2x.e3c68afb.jpg";